import Decimal from 'decimal.js';
import { ReportType } from '../schemas/report.schemas';

export function getReportUniqueBusinessKey(report: ReportType): string {
    return `${report.year}/${report.period}/${report.type}/${report.reportType}`;
}

export function getNumberOfDecimals(number: number) {
    return Decimal(number).decimalPlaces();
}
